import dayjs from "dayjs";
import { getPaginacionUsuarios } from "services/Usuarios";

// La API solo permite pedir "las últimas N postulaciones", no filtrar por fecha
// directamente. Las pantallas de Postulaciones traen un lote grande una sola vez
// y filtran/agrupan acá, del lado del navegador.
export const FETCH_LIMIT = 10000;

export const RANGE_OPTIONS = [
    { value: "hoy", label: "Hoy" },
    { value: "semana", label: "Última semana" },
    { value: "quincena", label: "Última quincena" },
    { value: "mes", label: "Último mes" },
    { value: "personalizado", label: "Personalizado" },
];

export const ESPONTANEA_VALUE = "espontanea";

export const getRangeBounds = (rangeType, customRange) => {
    const now = dayjs();

    switch (rangeType) {
        case "hoy":
            return [now.startOf("day"), now.endOf("day")];
        case "semana":
            return [now.subtract(6, "day").startOf("day"), now.endOf("day")];
        case "quincena":
            return [now.subtract(14, "day").startOf("day"), now.endOf("day")];
        case "mes":
            return [now.subtract(29, "day").startOf("day"), now.endOf("day")];
        case "personalizado":
            if (!customRange?.[0] || !customRange?.[1]) return [null, null];
            return [customRange[0].startOf("day"), customRange[1].endOf("day")];
        default:
            return [now.startOf("day"), now.endOf("day")];
    }
};

// Las postulaciones espontáneas (sin publicacion_id) solo traen un "cuenta_id"
// numérico, sin nombre ni link a la institución. Para completar ese dato traemos
// una sola vez el listado completo de instituciones y armamos un mapa
// cuenta_id -> {nombre, user_id}.
const INSTITUCIONES_CHUNK_SIZE = 200;
const INSTITUCIONES_MAX_PAGES = 100;

export const fetchInstitucionesMap = async () => {
    let page = 1;
    let all = [];
    let total = Infinity;

    while (all.length < total && page <= INSTITUCIONES_MAX_PAGES) {
        const response = await getPaginacionUsuarios("I", page, INSTITUCIONES_CHUNK_SIZE);
        const rows = response?.data || [];
        total = response?.pagination?.total ?? rows.length;
        all = all.concat(rows);
        if (rows.length === 0) break;
        page += 1;
    }

    const map = new Map();
    all.forEach((item) => {
        if (item?.cuenta?.id != null) {
            map.set(item.cuenta.id, { nombre: item.cuenta.nombre, user_id: item.cuenta.user_id });
        }
    });
    return map;
};

// Si es una postulación a una publicación concreta, la institución sale de
// publicacion.cuenta. Si es espontánea (sin publicacion_id), la resolvemos por
// cuenta_id contra el mapa de instituciones.
export const resolveInstitucion = (record, institucionesMap) => {
    if (record?.publicacion_id != null) {
        const cuenta = record.publicacion?.cuenta;
        return cuenta ? { nombre: cuenta.nombre, user_id: cuenta.user_id } : null;
    }
    return institucionesMap.get(record?.cuenta_id) || null;
};

// Clave estable para poder filtrar/agrupar por institución sin depender de que
// siempre tengamos user_id (fallback al nombre si hiciera falta).
export const institucionKey = (record, institucionesMap) => {
    const cuenta = resolveInstitucion(record, institucionesMap);
    if (!cuenta) return null;
    return cuenta.user_id != null ? `u:${cuenta.user_id}` : `n:${cuenta.nombre}`;
};
